import { useEffect, useState } from "react";
import {
    TextField,
    Button,
    Typography,
    Box,
    MenuItem,
    Grid,
    Stack,
} from "@mui/material";
import { addSpace } from "../../../service/spaceService";
import { Admin } from "../../../types/spaceTypes";
import { toast } from "react-toastify";
import { getAdmins } from "../../../service/spaceService";

const AddSpace = ({ onClose }: { onClose: () => void }) => {
    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = userData?.id;
    const userRole = userData?.role;

    const [formData, setFormData] = useState({
        space_name: "",
        space_type: "",
        owner_id: "",
    });

    const [admins, setAdmins] = useState<Admin[]>([]);
    const [loading, setLoading] = useState(false);

    const isBlocked = userRole === "superadmin" && admins.length === 0;


    const fetchAdmins = async () => {
        try {
            setLoading(true)
            const data = await getAdmins();
            setAdmins(data)
        } catch {
            console.error("Failed to fetch admins");
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchAdmins()
    }, [userRole === 'superadmin'])

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            const final_owner_id = userRole === "admin" ? userId : formData.owner_id;
            const dataToSend = {
                ...formData,
                space_type: formData.space_type || "admin",
                admin_id: final_owner_id,
            };

            await addSpace(dataToSend);
            toast.success("Space added successfully!");
            onClose(); // Close modal after adding a user
        } catch (error) {
            console.error("Failed to add space", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ width: "600px", p: 3 }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
                Add New Space (Admin)
            </Typography>

            {isBlocked && (
                <Typography variant="body2" color="error" mb={2}>
                    No admins available. Please create an admin before creating a space.
                </Typography>
            )}

            <Grid container spacing={2}>
                {/* First Row - Owner */}
                {userRole === "superadmin" && (
                    <Grid item xs={6}>
                        <TextField select fullWidth label="Owner" name="owner_id" value={formData.owner_id} onChange={handleChange} disabled={isBlocked} required>
                            {admins.map((admin) => (
                                <MenuItem value={admin.id}>{admin.name}</MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                )}

                {/* Second Row - Space Name */}
                <Grid item xs={12}>
                    <TextField fullWidth label="Space Name" name="space_name" value={formData.space_name} disabled={isBlocked} onChange={handleChange} required />
                </Grid>

                {/* Buttons */}
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="space-between">
                        <Stack direction="row" spacing={2}>
                            <Button variant="contained" color="primary" type="submit" disabled={loading || isBlocked}>
                                {loading ? "Saving..." : "Create Space"}
                            </Button>
                        </Stack>
                        <Button variant="outlined" color="secondary" onClick={onClose}>
                            Cancel
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AddSpace;
